import { useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useParams } from "react-router";
import {
  fetchAmberPlusCrossPageDataIfNeeded,
  setAmberPlusCrossMeta,
} from "./data/amberPlusCrossReducer";

const useAmberPlusCross = () => {
  const dispatch = useDispatch();
  const { service: slug } = useParams<{ service?: string }>();

  const { isError, isStatus500 } = useSelector(
    (state: any) => ({
      isError: state.amberPlusCrossPageData?.readyStatus === "failure",
      isStatus500: !JSON.stringify(state.amberPlusCrossPageData?.error)?.includes("404"),
    }),
    shallowEqual,
  );

  useEffect(() => {
    dispatch(fetchAmberPlusCrossPageDataIfNeeded());
  }, [dispatch]);

  useEffect(() => {
    dispatch(setAmberPlusCrossMeta(slug, window.location.href));
  }, [dispatch, slug]);

  return { isError, isStatus500 };
};

export default useAmberPlusCross;
